
const moment = require('moment');

var internalDateFormat = "YYYY-MM-DD";
var internalDateTimeFormat = "YYYY-MM-DD HH:mm:ss";

function convertToUTCDateMoment (value)
{
    return moment.utc(value, internalDateFormat, true);
}

function convertToUTCDateTimeMoment (value)
{
    return moment.utc(value, internalDateTimeFormat, true);
}

function convertToUTCMoment (value)
{
    var convertedValue = convertToUTCDateMoment(value);
    if (convertedValue.isValid())
        return convertedValue;

    convertedValue = convertToUTCDateTimeMoment(value);
    if (!convertedValue.isValid())
        throw `${value} is not a correct date/time formatted value`;

    return convertedValue;
}

function alignMomentByStartOrEndOfMonth(sourceMoment, resultMoment)
{
    const source = sourceMoment.clone().startOf("day");   
    const result = resultMoment.clone().startOf("day");  

    if (source.clone().startOf("month").isSame(source))
    {
        return result.startOf("month");
    }

    else if (source.clone().endOf("month").startOf("day").isSame(source))
    {
        return result.endOf("month");
    }

    return resultMoment.clone();
}

module.exports.internalDateFormat = internalDateFormat;
module.exports.internalDateTimeFormat = internalDateTimeFormat;
module.exports.convertToUTCMoment = convertToUTCMoment;

/*******************************************************************************************/
module.exports.getDateFormat = ()=> internalDateFormat

module.exports.getDateTimeFormat = ()=> internalDateTimeFormat

module.exports.getLongDateFormat = ()=> 
{
    // moment/js format tokens
    // https://momentjs.com/docs/#/displaying/
    
    return "dddd, MMMM Do YYYY";    // Sunday, February 14th 2010
}

module.exports.getHourMinuteFormat = ()=> "HH:mm"

/*******************************************************************************************/
module.exports.formatDate = (dateValue, format)=> convertToUTCMoment(dateValue).format(format)

module.exports.formatUtcMomentToDate = (utcMoment)=> utcMoment.format(internalDateFormat)

module.exports.formatUtcMomentToDateTime = (utcMoment)=> utcMoment.format(internalDateTimeFormat)

module.exports.convertFromISODateTimeFormat = (value)=> 
{
    value = value.replace("T", " ");
    value = value.replace("t", " ");
    value = value.replace("Z", "");
    var timeComponents = value.split(/[- :]/);

    return `${timeComponents[0]}-${timeComponents[1]}-${timeComponents[2]} ${timeComponents[3]}:${timeComponents[4]}:${timeComponents[5].split(".")[0]}`
}

module.exports.convertFromUnixEpochDateTimeFormat = (value)=> moment(value, 'x', true).utc().format(internalDateTimeFormat)

module.exports.convertUTCToISODateTimeFormat = function (value)
{
    if(!this.isValidDateTime(value))
        throw "Input value is not valid datetime format"
    
    value = value.replace(" ", "T");
    return `${value}.000Z`;
}

/*******************************************************************************************/
module.exports.getToday = ()=> moment().utc().format(internalDateFormat)

module.exports.getNow = ()=> moment().utc().format(internalDateTimeFormat)



/*******************************************************************************************/
module.exports.isValidDate = (value)=> convertToUTCDateMoment(value).isValid()

module.exports.isValidDateTime = (value)=> convertToUTCDateTimeMoment(value).isValid()

module.exports.isValidDateOrDateTime = function (value)
{
    return this.isValidDate(value) || this.isValidDateTime(value);
}



/*******************************************************************************************/
module.exports.isDateComponentSame = function (value1, value2)
{
    return  this.isSame(convertToUTCMoment(value1).format(internalDateFormat), convertToUTCMoment(value2).format(internalDateFormat));
}

module.exports.isSame = (value1, value2)=> convertToUTCMoment(value1).isSame(convertToUTCMoment(value2))

module.exports.isAfter = (value1, value2)=> convertToUTCMoment(value1).isAfter(convertToUTCMoment(value2))

module.exports.isBefore = (value1, value2)=> convertToUTCMoment(value1).isBefore(convertToUTCMoment(value2))

module.exports.isSameOrAfter = (value1, value2)=> convertToUTCMoment(value1).isSameOrAfter(convertToUTCMoment(value2))

module.exports.isSameOrBefore = (value1, value2)=> convertToUTCMoment(value1).isSameOrBefore(convertToUTCMoment(value2))


/*******************************************************************************************/
module.exports.differenceInMilliseconds = (dateValue1, dateValue2)=> moment.duration(convertToUTCMoment(dateValue1).diff(convertToUTCMoment(dateValue2))).asMilliseconds()

module.exports.differenceInSeconds = (dateValue1, dateValue2)=> moment.duration(convertToUTCMoment(dateValue1).diff(convertToUTCMoment(dateValue2))).asSeconds()

module.exports.differenceInMinutes = (dateValue1, dateValue2)=> moment.duration(convertToUTCMoment(dateValue1).diff(convertToUTCMoment(dateValue2))).asMinutes()

module.exports.differenceInHours = (dateValue1, dateValue2)=> moment.duration(convertToUTCMoment(dateValue1).diff(convertToUTCMoment(dateValue2))).asHours()

module.exports.differenceInDays = (dateValue1, dateValue2)=> moment.duration(convertToUTCMoment(dateValue1).diff(convertToUTCMoment(dateValue2))).asDays()




/*******************************************************************************************/
module.exports.addMinutes  = (dateValue, noOfMinutes)=> convertToUTCMoment(dateValue).add(noOfMinutes, 'minutes').format(internalDateTimeFormat)

module.exports.addHours = (dateValue, noOfHours)=> convertToUTCMoment(dateValue).add(noOfHours, 'hours').format(internalDateTimeFormat)

module.exports.addDays  = function(dateValue, count = 1)
{
    if (this.isValidDate(dateValue))
        return convertToUTCMoment(dateValue).add(count, 'days').format(internalDateFormat);

    return convertToUTCMoment(dateValue).add(count, 'days').format(internalDateTimeFormat);
}

module.exports.addWeeks = function (dateValue, count = 1)
{

    if (this.isValidDate(dateValue))
        return convertToUTCMoment(dateValue).add(count, 'weeks').format(internalDateFormat);

    return convertToUTCMoment(dateValue).add(count, 'weeks').format(internalDateTimeFormat);
}

module.exports.addMonths = function (dateValue, count = 1)
{
    if (this.isValidDate(dateValue))
    {
        var result = convertToUTCMoment(dateValue).add(count, 'months').format(internalDateFormat);
        return alignMomentByStartOrEndOfMonth(convertToUTCMoment(dateValue), convertToUTCMoment(result)).format(internalDateFormat);
    }
    
    var result = convertToUTCMoment(dateValue).add(count, 'months').format(internalDateTimeFormat);
    return alignMomentByStartOrEndOfMonth(convertToUTCMoment(dateValue), convertToUTCMoment(result)).format(internalDateTimeFormat);
}

module.exports.addQuarters = function (dateValue, count = 1)
{
    if (this.isValidDate(dateValue))
    {
        var result = convertToUTCMoment(dateValue).add(count, 'quarters').format(internalDateFormat);
        return alignMomentByStartOrEndOfMonth(convertToUTCMoment(dateValue), convertToUTCMoment(result)).format(internalDateFormat);
    }
    
    var result = convertToUTCMoment(dateValue).add(count, 'quarters').format(internalDateTimeFormat);
    return alignMomentByStartOrEndOfMonth(convertToUTCMoment(dateValue), convertToUTCMoment(result)).format(internalDateTimeFormat);
}

module.exports.addSemiYears = function (dateValue, count = 1)
{
    return this.addMonths(dateValue, count * 6);
}

module.exports.addYears = function (dateValue, count = 1)
{
    if (this.isValidDate(dateValue))
    {
        var result = convertToUTCMoment(dateValue).add(count, 'years').format(internalDateFormat);
        return alignMomentByStartOrEndOfMonth(convertToUTCMoment(dateValue), convertToUTCMoment(result)).format(internalDateFormat);
    }
    
    var result = convertToUTCMoment(dateValue).add(count, 'years').format(internalDateTimeFormat);
    return alignMomentByStartOrEndOfMonth(convertToUTCMoment(dateValue), convertToUTCMoment(result)).format(internalDateTimeFormat);
}



/*******************************************************************************************/
module.exports.subtractDays = function (dateValue, noOfDays = 1)
{
    if (this.isValidDate(dateValue))
        return convertToUTCMoment(dateValue).subtract(noOfDays, 'days').format(internalDateFormat);

    return convertToUTCMoment(dateValue).subtract(noOfDays, 'days').format(internalDateTimeFormat);
}

module.exports.subtractWeeks = function (dateValue, count = 1)
{

    if (this.isValidDate(dateValue))
        return convertToUTCMoment(dateValue).subtract(count, 'weeks').format(internalDateFormat);

    return convertToUTCMoment(dateValue).subtract(count, 'weeks').format(internalDateTimeFormat);
}

module.exports.subtractMonths = function (dateValue, count = 1)
{
    if (this.isValidDate(dateValue))
    {
        var result = convertToUTCMoment(dateValue).subtract(count, 'months').format(internalDateFormat);
        return alignMomentByStartOrEndOfMonth(convertToUTCMoment(dateValue), convertToUTCMoment(result)).format(internalDateFormat);
    }
    
    var result = convertToUTCMoment(dateValue).subtract(count, 'months').format(internalDateTimeFormat);
    return alignMomentByStartOrEndOfMonth(convertToUTCMoment(dateValue), convertToUTCMoment(result)).format(internalDateTimeFormat);
}

module.exports.subtractQuarters = function (dateValue, count = 1)
{
    if (this.isValidDate(dateValue))
    {
        var result = convertToUTCMoment(dateValue).subtract(count, 'quarters').format(internalDateFormat);
        return alignMomentByStartOrEndOfMonth(convertToUTCMoment(dateValue), convertToUTCMoment(result)).format(internalDateFormat);
    }
    
    var result = convertToUTCMoment(dateValue).subtract(count, 'quarters').format(internalDateTimeFormat);
    return alignMomentByStartOrEndOfMonth(convertToUTCMoment(dateValue), convertToUTCMoment(result)).format(internalDateTimeFormat);
}

module.exports.subtractSemiYears = function (dateValue, count = 1)
{
    return this.subtractMonths(dateValue, count * 6);
}

module.exports.subtractYears = function (dateValue, count = 1)
{
    if (this.isValidDate(dateValue))
    {
        var result = convertToUTCMoment(dateValue).subtract(count, 'years').format(internalDateFormat);
        return alignMomentByStartOrEndOfMonth(convertToUTCMoment(dateValue), convertToUTCMoment(result)).format(internalDateFormat);
    }
    
    var result = convertToUTCMoment(dateValue).subtract(count, 'years').format(internalDateTimeFormat);
    return alignMomentByStartOrEndOfMonth(convertToUTCMoment(dateValue), convertToUTCMoment(result)).format(internalDateTimeFormat);
}


/*******************************************************************************************/
module.exports.setDateComponent = (dateValue, date, month, year)=> 
{
    var format = internalDateTimeFormat;
    if (convertToUTCDateMoment(dateValue).isValid())
        format = internalDateFormat;
    

    return convertToUTCMoment(dateValue)
            .set("date", date)
            .set("month", month)
            .set("year",year)
            .format(format);
}

module.exports.setSeconds = (dateValue, seconds)=> convertToUTCMoment(dateValue).seconds(seconds).format(internalDateTimeFormat)

module.exports.setMinutes = (dateValue, minutes)=> convertToUTCMoment(dateValue).minute(minutes).format(internalDateTimeFormat)

module.exports.setHours = (dateValue, hours)=> convertToUTCMoment(dateValue).hour(hours).format(internalDateTimeFormat)

module.exports.setTimeComponent = (dateValue, hours, minutes, seconds)=> 
{
    if(hours < 0 || hours > 23)
        throw Error('Hours can only be set to value from 0 to 23');
    if(minutes < 0 || minutes > 59)
        throw Error('Minutes can only be set to value from 0 to 59');
    if(seconds < 0 || seconds > 59)
        throw Error('Seconds can only be set to value from 0 to 59');

    return convertToUTCMoment(dateValue)
            .hour(hours)
            .minute(minutes)
            .second(seconds)
            .format(internalDateTimeFormat);
}

/*******************************************************************************************/
module.exports.getDateComponent = (dateValue)=> convertToUTCMoment(dateValue).format(internalDateFormat)

module.exports.getMinutes = (dateValue)=> convertToUTCMoment(dateValue).minute()

module.exports.getHours = (dateValue)=> convertToUTCMoment(dateValue).hour()

module.exports.getDay = (dateValue)=> convertToUTCMoment(dateValue).day()

module.exports.getDayName = function (dateValue)
{
    return this.formatDate(dateValue, 'dddd');
}

module.exports.getMonth = (dateValue)=> convertToUTCMoment(dateValue).month()

module.exports.getYear = (dateValue)=> convertToUTCMoment(dateValue).year()

module.exports.getDate = (dateValue)=> convertToUTCMoment(dateValue).date()

module.exports.getStartOfDay = function (value)
{
    return this.convertToUTCMoment(value).startOf("day").format(internalDateTimeFormat);
}

module.exports.getEndOfDay = function (value)
{
    return this.convertToUTCMoment(value).endOf("day").format(internalDateTimeFormat);
}

module.exports.getStartOfMonth = function (value)
{
    var month = this.getMonth(value);
    var year = this.getYear(value);
    return this.setDateComponent(value, 1, month, year);
}

module.exports.getEndOfMonth = function (value)
{
    value = this.getStartOfMonth(value);
    value = this.addMonths(value, 1);
    value = this.subtractDays(value, 1);
    return value;
}


/*******************************************************************************************/
module.exports.convertToUTCStandard = (value)=> 
{
    var convertedValue = convertToUTCDateMoment(value);
    if (convertedValue.isValid())
    {
        return convertedValue.format(internalDateFormat);
    }

    return moment(value, internalDateTimeFormat, true).utc().format(internalDateTimeFormat);
}

module.exports.convertToLocalStandard = (value)=> 
{
    var convertedValue = convertToUTCDateMoment(value);
    if (convertedValue.isValid())
    {
        return convertedValue.format(internalDateFormat);
    }

    return convertToUTCDateTimeMoment(value).local().format(internalDateTimeFormat);
}

module.exports.monthNames =
    [
        "Invalid Index",
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];
